import { RollbackType } from '../components/Tadvance';
import { GameNames } from '../store/slices/GameTypes';
import { store } from '../store/store';
import { GameObject, setInputText, TextInputINT, TimageINT } from './../store/slices/gameObjectSlice';
import { Action, Node } from "./Actions/Action";
import * as funcs from "../components/functions";
import { GameEndings, setMenu } from '../store/slices/menuSlice';
import { CombinedState } from '@reduxjs/toolkit';
import { StateWithHistory } from 'redux-undo';
import { TScenesReplay } from '../components/menu/Scenes/replayScenes/ScenesReplay';

interface GameQueue {
    id: number,
    action: Function;
}

// export enum GameActionTypes{
//     GAME_OBJECT = "GAME_OBJECT",
//     PHONE = "PHONE"
// }

export type GameVersion = '0.7a1.01' | '0.7a2.01' | '0.7b' | '0.7b0.2' | "V0.7" | "0.8a1" | "0.8.2a" | "0.8.3a" | "0.8b" | "0.8.1b" | "0.9a";

// async function endReplay() {
//     console.log("ending replay");
// }

export default class Game {
    static version: GameVersion = `0.9a`;
    static currentScene: string;
    // static queue: Array<GameQueue> = [];
    // static queueIndex = 0;
    static Action: Node<Function> | null | undefined;
    static skip: boolean = false;
    static lastActionType = '';
    static rollback: RollbackType = 0;
    static isReplayRunning: TScenesReplay | null = null;
    static replayState: CombinedState<{ gameObject: StateWithHistory<GameObject>; }> | null = null;
    // static endReplay = endReplay;
    static seenScenarios: string[] = [];
    static seenImages: string[] = [];
    // TODO: change each version till I have automatic script
    // static actionPromise: (value: unknown) => void;
    constructor() {

    }
    private static _initialize = (() => {
        Object.defineProperty(Game, "seenScenarios", {
            get: () => {
                return store.getState().gameObject.present.seenScenarios;
            },

        });
        Object.defineProperty(Game, "seenImages", {
            get: () => {
                return store.getState().advance.globalSeenImages;
            },

        });
        Object.defineProperty(Game, "currentScene", {
            get: () => {
                return store.getState().gameObject.present.currentScene;
            },

        });
    })();
    static showInput(data: TextInputINT): Promise<any> {
        return new Action(data, GameNames.INPUT).run(
            function inputText(callback: () => void) {
                store.dispatch(setInputText({ ...data, display: true }));
                callback();
            }
            , false);
    }
    static getCurrentImage(): TimageINT {
        return store.getState().gameObject.present.image;
    }
    static loadGame(gameObject: GameObject) {
        if (gameObject) {
            // return funcs.globals(gameObject);
        }
        return gameObject;

    }
    static showEnding(ending: GameEndings) {
        Game.rollback = 1;
        store.dispatch(setMenu({ showEnding: ending, display: true }));


    }

}